export default __webpack_public_path__ + "static/media/Video.a9e13100.svg";